// extracted by mini-css-extract-plugin
module.exports = {"pageGroupWrapper":"_1gF1C","pageGroup":"_2YGAo"};